import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

const RESOURCE = "/settings/email-notifications";

export interface EmailNotificationSettings {
  client_email_notifications_enabled: boolean;
  appointment_created_notifications_enabled: boolean;
  appointment_reminder_notifications_enabled: boolean;
  appointment_reminder_hours_before: number;
  notify_on_created_default: boolean;
  notify_reminder_default: boolean;
  client_email_reply_to: string | null;
}

export interface EmailNotificationUsage {
  transactional_count: number;
  campaign_count: number;
  limit: number | null;
  is_free: boolean;
  is_near_limit: boolean;
  is_at_limit: boolean;
}

export interface EmailNotificationSettingsData {
  settings: EmailNotificationSettings;
  usage: EmailNotificationUsage;
}

export interface EmailNotificationPreviewData {
  subject: string;
  html: string;
}

export type UpdateEmailNotificationSettingsPayload = Partial<EmailNotificationSettings>;

export const REMINDER_HOUR_PRESETS = [1, 2, 12, 24, 48, 168] as const;

export const getEmailNotificationSettings = (): Promise<
  ApiResponse<EmailNotificationSettingsData>
> => api.get<ApiResponse<EmailNotificationSettingsData>>(RESOURCE);

export const getEmailNotificationCreatedPreview = (): Promise<
  ApiResponse<EmailNotificationPreviewData>
> => api.get<ApiResponse<EmailNotificationPreviewData>>(`${RESOURCE}/preview-created`);

export const getEmailNotificationDepositPendingPreview = (): Promise<
  ApiResponse<EmailNotificationPreviewData>
> =>
  api.get<ApiResponse<EmailNotificationPreviewData>>(
    `${RESOURCE}/preview-deposit-pending`
  );

export const updateEmailNotificationSettings = (
  payload: UpdateEmailNotificationSettingsPayload
): Promise<ApiResponse<EmailNotificationSettingsData>> =>
  api.update<ApiResponse<EmailNotificationSettingsData>>(RESOURCE, payload);

export const isEmailUsageNearLimit = (usage: EmailNotificationUsage): boolean =>
  usage.is_free && (usage.is_near_limit || usage.is_at_limit);
